const monitor = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M16 1H0v11h7v1.5H2.5V15h11v-1.5H9V12h7zM1.5 10.5v-8h13v8z"/></svg>',
};

export { monitor as default };
